// lib
import railsPostFetch from '@aytm/lib/common/rails-post-fetch'
import { call } from 'redux-saga/effects'

// stores
import staticStore from '@aytm/app/insights/dashboard/stores/static.store'

export default function* updateSourceSaga(schema, surveys) {
  if (!staticStore.canUpdateDashboard) {
    return null
  }
  const updateSourceURL = staticStore.urls.updateSource
  if (!updateSourceURL) {
    throw new Error('No "updateSource" endpoint URL')
  }
  const response = yield call(railsPostFetch, updateSourceURL, {
    body: JSON.stringify({ schema: schema.toJS(), surveys })
  })
  if (!response.ok) {
    throw new Error(response.error || 'Error updating source')
  }
  const body = yield call([response, 'json'])
  if (!body.status) {
    throw new Error('Error updating source')
  }
  return body
}
